import _ from 'lodash'

function camelCaseKeys (obj, context) {
  return _.transform(obj, function (result, val, key) {
    result[_.camelCase(key)] =
        _.isObject(val) /* && !_.isDate(val)*/
            ? camelCaseKeys(val, context)
            : val
  })
}

export default camelCaseKeys
